import CONFIG from "@/assets/js/config.custom.js";
import axios from "axios";
import EmployeeDetail from "@/controllers/employee/employee-profile.js";

export default {
    extends: EmployeeDetail,
    data() {
        return {
        config: CONFIG,
        period: {},
        isLoading: false,
        noDataMsg: "No Data Available",
        };
    },

    mounted() {
        this.getPeriodDetail();
    },

    methods : {
        /**
         * Get period detail
         */
        getPeriodDetail() {
            this.isLoading = true;
            axios.get(`period/detail/${this.$route.params.id}`)
                .then(response => {
                    this.period = response.data;
                    this.getTermsByAcdYearId(this.period.id);
                })
                .catch(error => {
                    console.error("Error fetching period detail:", error);
                    this.isLoading = false;
                });
        },

        /**
         * Get terms by academic year ID
         */
        getTermsByAcdYearId(acdYearId) {
            axios.get(`period/${acdYearId}/term/list`)
                .then(response => {
                    this.$set(this.period, 'terms', response.data.terms);
                    this.isLoading = false;
                })
                .catch(error => {
                    console.error("Error fetching terms:", error);
                    this.isLoading = false;
                });
        },

/**
         * Delete term
         */
        deleteTerm(termId) {
            axios.delete(`period/${this.$route.params.id}/term/delete/${termId}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$notification.success("Term Deleted Successfully", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else {
                        this.$notification.error("Term Delete Failed", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                    this.getTermsByAcdYearId(this.period.id);
                })
                .catch(error => {
                    this.isLoading = false;
                    if (error.response && error.response.data && error.response.data.message) {
                        this.$notification.error(error.response.data.message, {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                });
        }
    }
};
